import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Callback, Login, VerifyMsg } from '@components/account';
import Home from '@components/home';
import ScanPanel from '@components/scan-panel';
import NotFound from './NotFound';
import ProtectedRoute from './Route';
import LayOut from './LayOut';
import Config from '@utils/config';
import FaceMatchingPanel from '@components/face-matching-panel';
import Redirect, { Redirection } from './Redirect';
import { Session } from '@models/account';
import {
    AGE_ANTISPOOFING_PATH,
    CALLBACK_PATH,
    FACE_MATCHING_PATH,
    LOGIN_PATH,
    ROOT_PATH,
    VERIFY_ACCOUNT_PATH,
} from '@utils/constants/Routes';

function loginRedirection(account: Session): Redirection {
    const should = !!account?.token && account?.verified && !account?.banned;
    return { should, path: ROOT_PATH };
}

function verifyRedirection(account: Session): Redirection {
    if (!account) {
        return { should: true, path: LOGIN_PATH };
    }
    const should = !!account.token && !!account.verified && !account.banned;
    return { should, path: ROOT_PATH };
}

const Router: React.FC = () => {
    return (
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
            <LayOut>
                <Routes>
                    <Route
                        path={ROOT_PATH}
                        element={
                            <ProtectedRoute>
                                {Config.showFaceMatching ? <Home /> : <ScanPanel />}
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={AGE_ANTISPOOFING_PATH}
                        element={
                            <ProtectedRoute>
                                <ScanPanel />
                            </ProtectedRoute>
                        }
                    />
                    {Config.showFaceMatching && (
                        <Route
                            path={FACE_MATCHING_PATH}
                            element={
                                <ProtectedRoute>
                                    <FaceMatchingPanel />
                                </ProtectedRoute>
                            }
                        />
                    )}
                    <Route
                        path={LOGIN_PATH}
                        element={
                            <ProtectedRoute anonymous>
                                <Redirect shouldRedirect={loginRedirection}>
                                    <Login />
                                </Redirect>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={CALLBACK_PATH}
                        element={
                            <ProtectedRoute anonymous>
                                <Callback />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={VERIFY_ACCOUNT_PATH}
                        element={
                            <ProtectedRoute anonymous>
                                <Redirect shouldRedirect={verifyRedirection}>
                                    <VerifyMsg />
                                </Redirect>
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="*"
                        element={
                            <ProtectedRoute anonymous>
                                <NotFound />
                            </ProtectedRoute>
                        }
                    />
                </Routes>
            </LayOut>
        </BrowserRouter>
    );
};

export default Router;
